import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createDataReduceObject } from '../../../../../common/reducers/data/reducer';
import faqContentsPopularSaga from './sagas/faqContentsPopularSaga';

export default [
  ...createCombineMapItem('faqContentsPopular', createDataReduceObject, [
    faqContentsPopularSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/reducers/static/objects/reducersMap.js